export const mergeWithState = (data, state) => {
  let newState = {};

  for (const [key, value] of Object.entries(state)) {
    if (data[key] != null) {
      if (
        typeof value === "object" &&
        typeof data[key] === "object" &&
        !Array.isArray(data[key])
      ) {
        newState[key] = { ...value, ...data[key] };
      } else {
        newState[key] = data[key];
      }
    } else {
      newState[key] = value;
    }
  }

  return newState;
};

export const fetchInstallationsFilters =
  (data) => async (dispatch, getState) => {
    const state = getState().installationsFilters;
    dispatch({
      type: "FETCH_INSTALLATIONS_FILTERS",
      payload: mergeWithState(data, state),
    });
  };

export const fetchAnalysisFilters = (data) => async (dispatch, getState) => {
  const state = getState().analysisFilters;
  dispatch({
    type: "FETCH_ANALYSIS_FILTERS",
    payload: mergeWithState(data, state),
  });
};

export const fetchTransactionsFilters =
  (data) => async (dispatch, getState) => {
    const state = getState().transactionsFilters;
    dispatch({
      type: "FETCH_TRANSACTIONS_FILTERS",
      payload: mergeWithState(data, state),
    });
  };

export const fetchCollectionsFilters = (data) => async (dispatch, getState) => {
  const state = getState().collectionsFilters;
  dispatch({
    type: "FETCH_COLLECTIONS_FILTERS",
    payload: mergeWithState(data, state),
  });
};

export const fetchSessionsFilters = (data) => async (dispatch, getState) => {
  const state = getState().sessionsFilters;
  dispatch({
    type: "FETCH_SESSIONS_FILTERS",
    payload: mergeWithState(data, state),
  });
};
export const fetchLiveFloorViewerFilters =
  (data) => async (dispatch, getState) => {
    const state = getState().LiveFloorViewerFilters;
    dispatch({
      type: "FETCH_LIVE_FLOOR_VIEWER_FILTERS",
      payload: mergeWithState(data, state),
    });
  };

export const fetchComplianceFilters = (data) => async (dispatch, getState) => {
  const state = getState().complianceFilters;
  dispatch({
    type: "FETCH_COMPLIANCE_FILTERS",
    payload: mergeWithState(data, state),
  });
};

export const fetchCustomerFilters = (data) => async (dispatch, getState) => {
  const state = getState().customerFilters;
  dispatch({
    type: "FETCH_CUSTOMER_FILTERS",
    payload: mergeWithState(data, state),
  });
};

export const fetchSettingsFilters = (data) => async (dispatch, getState) => {
  const state = getState().settingsFilters;
  dispatch({
    type: "FETCH_SETTINGS_FILTERS",
    payload: mergeWithState(data, state),
  });
};

export const fetchKioskFilters = (data) => async (dispatch, getState) => {
  const state = getState().kioskFilters;
  dispatch({
    type: "FETCH_KIOSK_FILTERS",
    payload: mergeWithState(data, state),
  });
};
